import * as THREE from 'three';

export default class FeatureStyler {

    static styleUnselected(mesh: THREE.Mesh | THREE.Points | THREE.Line) {
        (mesh.material as THREE.MeshBasicMaterial).color.set(new THREE.Color(mesh.userData.color));
    }

    static styleSelected(mesh: THREE.Mesh | THREE.Points | THREE.Line) {
        (mesh.material as THREE.MeshBasicMaterial).color.setHex(0xff0000);
    }

}
